module.exports = __webpack_public_path__ + "img/12312313_076.bc14ab6e.png";